import { Button, Input, message, Space, Spin, Switch } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import StaffDetailsModal from './staff-details.modal';
import './staff-search.css';
import { STAFF_DELETE_URL, STAFF_LIST_URL } from '../../api/URLs';
import { Delete, Edit, SearchOutlined } from '@mui/icons-material';
import { deleteDataRequest, getDataRequest, putDataRequest } from '../../api/serviceMethods';
import MessageConfirmModal from '../../components/messageModal/MessageConfirmModal';
import TableFetchData from '../../components/data-table/TableFetchData';
import { useTranslation } from 'react-i18next';
import { ImageComponent } from '../../components/image/ImageComponent';
import DateComponent from '../../components/date/DateComponent';
import { EditOutlined, DeleteOutlined, EyeOutlined, AudioOutlined } from '@ant-design/icons';
import EditTableSvg from '../../assets/images/EditTable';
import DeleteTableSvg from '../../assets/images/DeleteTable';
import ViewTableSvg from '../../assets/images/ViewTable';
import PermissionTextComponent from './PermissionTextComponent';
import { useSelector } from 'react-redux';
import DateRangeComponent from '../../components/date/DateRangeComponent';


function StaffSearchPage() {
  const [loading, setLoading] = useState(false);
  const [showStaff, setShowStaff] = useState({ show: false, staffId: '' });
  const [staffData, setStaffData] = useState([])
  const [searchResult, setSearchResult] = useState([]);
  const messageModalRef = useRef('')
  const navigate = useNavigate();
  const [keyword, setkeyword] = useState('');
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
      total: 0,
    },
  });
  const [dates, setDates] = useState([null, null]);//useState([`2019-09-03`, `2019-11-22`]);
  const { t } = useTranslation()
  const user = useSelector((state) => state.authenticatedUser);

  const displayStaff = (staffId) => {
    setShowStaff({ show: true, staffId });
  };

  const tableStaffMangement = {
    appendable: false,
    removable: false,
    bordered: false,
    numbered: true,
    size: 'middle',
    pagination: {
      showLessItems: true,
      showSizeChanger: false,
      pageSize: 20,
    },
    columns: [
      {
        title: <label className="titleCard14400">{t('employee_Avatar')}</label>,
        render: (_, staff) => {
          return (
            <ImageComponent scr={staff.picUrl} />
          )
        }
      },
      {
        title: <label className="titleCard14400">{t('employee_name')}</label>,
        render: (_, staff) => {
          return (
            <label className="text-capitalize text-wrap-nowrap">{staff && staff.name}</label>
          )
        }
      },
      {
        title: <label className="titleCard14400">{t('employee_email')}</label>,
        dataIndex: 'email',
      },
      {
        title: <label className="titleCard14400">{t('employee_Permission')}</label>,
        render: (_, staff) => {
          return (
            <PermissionTextComponent haveAccess={staff && staff.permissions ? staff.permissions : []} />
          )
        }
      },
      {
        title: <label className="titleCard14400">{t('Operator')}</label>,
        width: 120,
        render: (_, member) => {
          return (
            <Space size="middle">
              <Switch checked={member.status} disabled={user && user.staffId === member.staffId} onChange={() => user && user.staffId !== member.staffId && hadleUpdateStaff(member, member.status)} />
              <span style={{ cursor: "pointer" }}
                onClick={() => navigate(`/staff/create?id=${member.staffId}`)}>
                <EditTableSvg />
              </span>
              <span style={{ cursor: "pointer" }}
                className={`${user && user.staffId === member.staffId && 'cursor-no-drop'}`}
                onClick={() => user && user.staffId !== member.staffId && deleteStaffData(member && member.staffId)}>
                <DeleteTableSvg />
              </span>
              <span style={{ cursor: "pointer" }}
                onClick={() => {
                  displayStaff(member.staffId);
                }}>
                <ViewTableSvg />
              </span>
            </Space>
          )
        },
      },
    ],
  };

  const insertParams = (dataObject) => {
    const memberPayload = {
      "email": dataObject.email,
      "name": dataObject.name,
      "picUrl": dataObject.picUrl,
      "permissions": dataObject.permissions,
      "status": !dataObject.status
    }
    return memberPayload
  }
  const hadleUpdateStaff = async (item) => {
    try {
      const memberPayload = insertParams(item)
      setLoading(true);
      await putDataRequest(`/staffs/update/${item.staffId} `, memberPayload)
        .then((res) => {
          if (res.status === 200) {

            messageModalRef.current.showSuccessConfirmsAutoClose(
              t('staffMesage.updateStatusSuccess', {
                name: item?.name || "",
                staffId: res?.staffId,
              }), () => { }, "", true);
            filterTableResult('');
            initLoadStaffData()
            setTimeout(() => {
              setLoading(false);
            }, 1000);
          } else {
            messageModalRef.current.showWarningConfirmsAutoClose(res && t(res.message), () => { }, "", true);
          }
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          messageModalRef.current.showWarningConfirmsAutoClose(err && err.response && err.response.data && err.response.data.message || "Server Error!", () => { }, "", true);
        });
    } catch (error) {
      setLoading(false);
      messageModalRef.current.showWarningConfirmsAutoClose(t(`Server Error!`), () => { }, "", true);
    }
  }

  const formatStaffData = (staffData) => {
    let staffDataCopy = JSON.parse(JSON.stringify(staffData));
    staffDataCopy.forEach((staff) => {
      staff.name = staff.name;
    });
    setSearchResult(
      staffData.map((staff) => ({
        ...staff,
        email: staff.email || '',
        gender: staff.gender || '',
        staffId: staff.staffId || '',
        role: staff.role || '',
        roles: ["用户管理", "收款管理", "杂志管理", "资讯管理", "账户管理"],
      }))
    );
  };

  useEffect(() => {
    filterTableResult('');
  }, [searchResult]);

  const filterTableResult = (value) => {
    // const regex = new RegExp(value, 'i');
    const newStaffList = searchResult.filter((staff) => {
      return true
      // return (
      //   regex.test(staff.number) ||
      //   regex.test(staff.name) ||
      //   regex.test(staff.staffId) ||
      //   regex.test(staff.gender) ||
      //   regex.test(staff.email) ||
      //   regex.test(staff.role)
      // );
    });
    setStaffData(newStaffList);
  };

  // for list all staff
  const initLoadStaffData = async (value) => {
    setLoading(true);
    await getDataRequest(`${STAFF_LIST_URL}`, {
      pageNo: tableParams.pagination.current,
      pageSize: tableParams.pagination.pageSize,
      keyword: value ? value.trim() : '',
      startDate: dates[0] ? dates[0] : '',
      endDate: dates[1] ? dates[1] : '',
    }).then((res) => {
      if (res.status === 200) {
        formatStaffData(res?.data);
      }
      setTableParams({
        ...tableParams,
        pagination: {
          ...tableParams.pagination,
          total: res.total,
        },
      });
      setLoading(false);
    }).catch((err) => {
      setLoading(false)
      console.log("Error", err)
    });
  };

  const deleteStaffData = async (item) => {
    messageModalRef.current.showWarningConfirm(t('Are you sure you want to delete this employee ?'), async () => {
      setLoading(true)
      await deleteDataRequest(`${STAFF_DELETE_URL}/${item}`).then((res) => {
        messageModalRef.current.showSuccessConfirmsAutoClose(res && res.message, () => { }, "", true);
        initLoadStaffData();
        setLoading(false)
      }).catch((err) => {
        messageModalRef.current.showWarningConfirmsAutoClose(err|| "Server Error!", () => { }, "", true);
        setLoading(false)
      });
    }, "", true);
  };
  const [isSearch, setIsSearch] = useState(true)
  useEffect(() => {
    isSearch && initLoadStaffData(keyword)
  }, [
    tableParams.pagination?.current,
    tableParams.pagination?.pageSize,
    tableParams?.sortOrder,
    tableParams?.sortField,
    JSON.stringify(tableParams.filters),isSearch
  ]);


  return (
    <div className="container- box-shadow h-100"
      style={{
        // background: "0% 0% no-repeat padding-box padding-box rgb(240, 242, 245)",
        // padding: "32px",
        // overflow: "auto"
      }}>
      <StaffDetailsModal
        show={showStaff.show}
        staffId={showStaff.staffId}
        handleClose={() => setShowStaff({ show: false, staffId: '' })}
      />
      <div className="w-100 h-100 overflow-auto" style={{padding:"0px 25px"}}>
        <Spin spinning={loading}>
          <div className="w-100">
            <div className="d-flex justify-content-between mt-3 mb-3">
              <div className="d-flex align-items-center col-6 row">
                <div className='col-6'>
                  <Input
                    placeholder={t('employee_search')}
                    size="large"
                    disabled={loading}
                    allowClear
                    prefix={
                      <SearchOutlined
                        onClick={() => {
                          // filterTableResult(keyword);
                          // setTableParams({
                          //   ...tableParams,
                          //   pagination: {
                          //     ...tableParams.pagination,
                          //     current: 1,
                          //     total: 0,
                          //   },
                          // });
                          // initLoadStaffData(keyword);
                        }}
                        style={{
                          color: '#8c8c8c',
                          cursor: "pointer",
                          opacity: "0.4"
                        }}
                      />
                    }
                    onChange={(e) => {
                      const value = e.target.value;
                      setkeyword(value);

                      // if (value === "") {
                      //   setTableParams({
                      //     ...tableParams,
                      //     pagination: {
                      //       ...tableParams.pagination,
                      //       current: 1,
                      //       total: 0,
                      //     },
                      //   });
                      //   initLoadStaffData("");
                      // }
                    }}
                    onPressEnter={async (e) => {
                      // const value = e.target.value;
                      // filterTableResult(value);
                      // setTableParams({
                      //   ...tableParams,
                      //   pagination: {
                      //     ...tableParams.pagination,
                      //     current: 1,
                      //     total: 0,
                      //   },
                      // });
                      // if (value === "") {
                      //   initLoadStaffData("");
                      // } else {
                      //   initLoadStaffData(value);
                      // }
                    }}
                  />
                </div>
                <div className='col-6'>
                  <DateRangeComponent value={dates ? dates : [null, null]} setValue={(value) => {
                    setDates(value)
                    setTableParams({
                      ...tableParams,
                      pagination: {
                        ...tableParams.pagination,
                        current: 1,
                        total: 0,
                      },
                    });
                  }} />
                </div>
              </div>
              <div className='d-flex alight-items-center'>
                <Button size={'large'}
                  onClick={() => {
                    setTableParams({
                      ...tableParams,
                      pagination: {
                        ...tableParams.pagination,
                        current: 1,
                        total: 0,
                      },
                    });
                    setIsSearch(false)
                    setTimeout(() => {
                      setIsSearch(true)
                    }, 100);
                    // initLoadStaffData(keyword);
                  }}
                >
                  {t('btnSearch')}
                </Button>
                <div className="me-2 ms-2 d-flex align-items-center" style={{ height: "100%", borderLeft: "1px solid rgba(220, 220, 220, 0.83)" }}></div>
                <Button className='btngoCreate' size={'large'}
                  // type="primary" 
                  onClick={() => {
                    navigate(`/staff/create`)
                  }}
                >
                  {t('btnCreateAccount')}
                </Button>
              </div>
            </div>
          </div>

          <div className="w-100"
          // style={{ overflowY: "auto" }}
          >
            <TableFetchData
              tableParams={tableParams} setTableParams={setTableParams}
              data={staffData}
              columns={tableStaffMangement.columns}
              // loading={loading} setLoading={setLoading}
            />
          </div>
        </Spin>
      </div>
      <MessageConfirmModal textCentered ref={messageModalRef} />
    </div>
  );
}

export default StaffSearchPage;
